import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'removeDuplicates',
  version: '1.2.0',
  properties: [
    {
      key: 'inputArray',
      label: 'Input Array',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Data Engine API"].output.data }}',
      description: 'The array to remove duplicates from. Drag from the input panel or type the path.',
    },
    {
      key: 'field',
      label: 'Compare Field',
      type: 'string',
      required: false,
      placeholder: 'e.g., id or email',
      description: 'Field to compare for duplicates. Leave empty to compare entire objects.',
    },
  ],
};

export default schema;
